
import { START_PAGE } from "../../utils/Constant";
import { GET_ALL_USER_DATA } from "./ActionTypes";

export const getAllUserData = (payload, currentPage = START_PAGE) => ({
    type: GET_ALL_USER_DATA,
    payload,
    currentPage,
  });